<template>
    <div>
        <el-tree
            v-if="popover === false"
            highlight-current
            draggable
            node-key="id"
            :current-node-key="selectNodeId"
            :default-expanded-keys="idExpandedArr"
            :expand-on-click-node="false"
            :data="treeData"
            :props="defaultProps"
            @node-click="handleTreeNode"
        />

        <el-popover
            v-if="popover === true"
            placement="bottom"
            width="200"
            trigger="focus"
            @after-enter='treeShow'>
            <el-tree
                highlight-current
                node-key="id"
                ref="tree"
                :current-node-key="selectNodeId"
                :default-expanded-keys="idExpandedArr"
                :expand-on-click-node="false"
                :data="treeData"
                :props="defaultProps"
                @node-click="handleTreeNode"
            />
            <el-input slot="reference" readonly v-model="popoverTreeLable"></el-input>
        </el-popover>
    </div>
</template>

<script>
    import { getResourceTreeList } from '@/data-model';
    export default {
        name: 'Resource',
        data () {
            return {
                idExpandedArr: [],
                treeData: [],
                selectNodeId: 0,
                popoverTreeLable: ''
            };
        },
        props: {
            rootId: { // 获取节点树结构数据时的根节点id
                type: [ Number, String ]
            },
            data: { // 外部传入的树的结构数据，如果没有传，使用组件自己的接口获取数据
                type: Array
            },
            selectedNode: { // 默认选中的树节点对象
                type: Object
            },
            defaultProps: { // 默认字段名配置
                type: Object
            },
            popover: { // 是否为弹出树
                type: Boolean,
                default: false
            }
        },
        created () {
            this._initPage().then(val => {
                // 初始化默认展开到第二级
                if (this.treeData && this.treeData.length > 0) {
                    this.idExpandedArr = [];
                    this.idExpandedArr.push(this.treeData[0].id);
                }
            });
        },
        methods: {
            async _initPage () {
                await this._getTreeData();
                this._setSelectedNode();
            },
            async _getTreeData () {
                let departmentTreeList = [];
                if (this.data) {
                    departmentTreeList = this.data;
                } else {
                    departmentTreeList = await getResourceTreeList(this.rootId);
                }
                this.treeData = departmentTreeList;
            },
            _setSelectedNode () {
                if (this.selectedNode) {
                    this.popoverTreeLable = this.selectedNode.label;
                    this.selectNodeId = this.selectedNode.id;
                }
            },
            _refreshSelectedNode (node) {
                if (node) {
                    this.popoverTreeLable = node.title;
                    this.selectNodeId = node.value;
                }
            },
            _refreshTreeData (newData) {
                if (newData) {
                    this.treeData = newData;
                }
            },
            handleTreeNode (data, node, tree) {
                this.popoverTreeLable = data.label;
                this.$emit('nodeClick', data, node, tree);
            },
            setTreeStatus () {
                this.$refs.tree.setCurrentNode(2);
            },
            treeShow () {
                // console.log('treeShow');
                // this.setTreeStatus();
                this.$emit('treeShow');
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/Resource/Resource.vue